// --- LAYOUT, COMPONENTS, PARTS --- //
$(function(){
	// ---  initialize --- //
    menuDropdownOff();

	// ---  LAYOUT --- //

	// ---  COMPONENTS --- //
	fn_components_fullscreen_navigation();
	fn_components_google_map();
	fn_components_slider();
	fn_components_gallery();
	fn_components_counter();


	// ---  PARTS --- //
	fn_parts_navigation_scroll_resize();
	fn_parts_placeholder();
});


// --- MISC --- //
$(function () {
	nl_fn_scroll_to();

    if($('.js-toggle-aside').length){
        $(document).on('click', '.js-toggle-aside', function(){
            $(this).closest('.aside-banner').toggleClass('open');
        });
    }
    $(document).click(function(e){
        if(!$(e.target).is('.js-toggle-aside')) {
            $('.aside-banner').removeClass('open');
        }
	});
});

// --- EVENTS --- //
$(window).resize(function(){
	fn_checkNavigationTrigger();
	fn_parts_navigation_scroll_resize();
    menuDropdownOff();
});

$(document).scroll(function () {
	fn_parts_navigation_scroll_resize();
});


$(window).bind('load', function () {
	fn_parts_dots();
});